<template>
  <section class="page-section" id="team">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase" style="color:#ea1e29">Fruit Calender</h2>
          <h3 class="section-subheading text-muted">
                 <v-card class="mx-auto" dark max-width="200px"> <v-card-text class="layout justify-center "><i  style="color:green;" class="fas fa-circle">On Season </i>  <i style="color:yellow;" class="fas fa-circle">Low season</i> <i style="color:red" class="fas fa-circle">Off Season</i></v-card-text></v-card>

          </h3>
        </div>
      </div>
      <div class="row">
        <!-- <div class="col-sm-4" v-for="(obj,key) in teamJSON" :key="key">
          <div class="team-member">
            <img class="mx-auto rounded-circle" :src="obj.teamImg" alt="">
            <h4>{{obj.teamName}}</h4>
            <p class="text-muted">{{obj.teamJob}}</p>
            <ul class="list-inline social-buttons">
              <li class="list-inline-item">
                <a href="#">
                  <i class="fab fa-twitter"></i>
                </a>
              </li>
              <li class="list-inline-item">
                <a href="#">
                  <i class="fab fa-facebook-f"></i>
                </a>
              </li>
              <li class="list-inline-item">
                <a href="#">
                  <i class="fab fa-linkedin-in"></i>
                </a>
              </li>
            </ul>
          </div>
        </div> -->
      </div>
  
      <v-card dark raised>
        <v-card-title>
            <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field></v-card-title>

            <v-data-table
              :headers="headers"
              :items="countries[0].desserts"
              item-key="name"
              :items-per-page="5"
              :search="search"
              
              class="section-heading text-uppercase"
            >
              <template v-slot:item.jan="{ item }">
                <i v-if="item.jan==='green'" style="color:green;" class="fas fa-circle"></i>
                <i v-else-if="item.jan==='yellow'" style="color:yellow;" class="fas fa-circle"></i>
                <i v-else style="color:red" class="fas fa-circle"></i>
              </template>
              <template v-slot:item.feb="{ item }">
                 <i v-if="item.feb==='green'" style="color:green;" class="fas fa-circle"></i>
                <i v-else-if="item.feb==='yellow'" style="color:yellow;" class="fas fa-circle"></i>
                <i v-else style="color:red" class="fas fa-circle"></i>
              </template>
              <template v-slot:item.march="{ item }">
                 <i v-if="item.march==='green'" style="color:green;" class="fas fa-circle"></i>
                <i v-else-if="item.march==='yellow'" style="color:yellow;" class="fas fa-circle"></i>
                <i v-else style="color:red" class="fas fa-circle"></i>
              </template>
              <template v-slot:item.april="{ item }">
                 <i v-if="item.april==='green'" style="color:green;" class="fas fa-circle"></i>
                <i v-else-if="item.april==='yellow'" style="color:yellow;" class="fas fa-circle"></i>
                <i v-else style="color:red" class="fas fa-circle"></i>
              </template>
              <template v-slot:item.may="{ item }">
                 <i v-if="item.may==='green'" style="color:green;" class="fas fa-circle"></i>
                <i v-else-if="item.may==='yellow'" style="color:yellow;" class="fas fa-circle"></i>
                <i v-else style="color:red" class="fas fa-circle"></i>
              </template>
              <template v-slot:item.june="{ item }">
                 <i v-if="item.june==='green'" style="color:green;" class="fas fa-circle"></i>
                <i v-else-if="item.june==='yellow'" style="color:yellow;" class="fas fa-circle"></i>
                <i v-else style="color:red" class="fas fa-circle"></i>
              </template>
              <template v-slot:item.july="{ item }">
                <i v-if="item.july==='green'" style="color:green;" class="fas fa-circle"></i>
                <i v-else-if="item.july==='yellow'" style="color:yellow;" class="fas fa-circle"></i>
                <i v-else style="color:red" class="fas fa-circle"></i>
              </template>
              <template v-slot:item.agst="{ item }">
                <i v-if="item.agst==='green'" style="color:green;" class="fas fa-circle"></i>
                <i v-else-if="item.agst==='yellow'" style="color:yellow;" class="fas fa-circle"></i>
                <i v-else style="color:red" class="fas fa-circle"></i>
              </template>
              <template v-slot:item.sept="{ item }">
                 <i v-if="item.sept==='green'" style="color:green;" class="fas fa-circle"></i>
                <i v-else-if="item.sept==='yellow'" style="color:yellow;" class="fas fa-circle"></i>
                <i v-else style="color:red" class="fas fa-circle"></i>
                
              </template>

              <template v-slot:item.oct="{ item }">
                <i v-if="item.oct==='green'" style="color:green;" class="fas fa-circle"></i>
                <i v-else-if="item.oct==='yellow'" style="color:yellow;" class="fas fa-circle"></i>
                <i v-else style="color:red" class="fas fa-circle"></i>
              </template>
              <template v-slot:item.nov="{ item }">
                 <i v-if="item.nov==='green'" style="color:green;" class="fas fa-circle"></i>
                <i v-else-if="item.nov==='yellow'" style="color:yellow;" class="fas fa-circle"></i>
                <i v-else style="color:red" class="fas fa-circle"></i>
              </template>
              <template v-slot:item.dec="{ item }">
                <i v-if="item.dec==='green'" style="color:green;" class="fas fa-circle"></i>
                <i v-else-if="item.dec==='yellow'" style="color:yellow;" class="fas fa-circle"></i>
                <i v-else style="color:red" class="fas fa-circle"></i>
              </template>
            </v-data-table>
      </v-card>
      
    </div>
  </section>
</template>
<script>
export default {
  data: () => ({
    teamJSON: [
      {
        teamImg: require("../assets/img/thomas.jpg"),
        teamName: "Thomas Jefferson",
        teamJob: "Software Analyst"
      }
    ],
     search: '',
  panel:1,
    selected2: [],
    headers: [
      { text: " ", value: "name", width: "10px", fixed: true },
      { text: "Jan", value: "jan", width: "10px", fixed: true },
      { text: "Feb", value: "feb", width: "10px", fixed: true },
      { text: "Mar", value: "march", width: "10px", fixed: true },
      { text: "Apr", value: "april", width: "10px", fixed: true },
      { text: "May", value: "may", width: "10px", fixed: true },
      { text: "Jun", value: "june", width: "10px", fixed: true },
      { text: "Jul", value: "july", width: "10px", fixed: true },
      { text: "Aug", value: "agst", width: "10px", fixed: true },
      { text: "Sep", value: "sept", width: "10px", fixed: true },
      { text: "Oct", value: "oct", width: "10px", fixed: true },
      { text: "Nov", value: "nov", width: "10px", fixed: true },
      { text: "Dec", value: "dec", width: "10px", fixed: true }
    ],
    countries: [{
        
        desserts: [
          {
            value: false,
            name: "Banana",
            category: "Beverage",
            jan: "green",

            feb: "green",
            march: "yellow",
            april: "yellow",
            may:"yellow",
            june: "green",
            july: "green",
            agst: "green",
            sept:"green",
            oct: "green",
            nov: "green",

            dec: "green"
          },
          {
            value: false,
            name: "Dragon Fruit",
            category: "Beverage",
            jan: "green",

            feb: "green",
            march: "green",
            april: "green",
            may:"green",
            june: "green",
            july: "green",
            agst: "green",
            sept:"green",
            oct: "yellow",
            nov: "yellow",

            dec: "yellow"
          },
          {
            value: false,
            name: "Durian",
            category: "Beverage",
            jan: "red",

            feb: "green",
            march: "green",
            april: "green",
            may:"green",
            june: "green",
            july: "green",
            agst: "green",
            sept:"yellow",
            oct: "yellow",
            nov: "red",

            dec: "red"
          },
          {
            value: false,
            name: "Jack Fruit",
            category: "Beverage",
            jan: "yellow",

            feb: "yellow",
            march: "green",
            april: "green",
            may:"green",
            june: "green",
            july: "green",
            agst: "green",
            sept:"yellow",
            oct: "yellow",
            nov: "yellow",

            dec: "yellow"
          },
          {
            value: false,
            name: "Lime",
            category: "Beverage",
            jan: "green",

            feb: "green",
            march: "green",
            april: "green",
            may:"green",
            june: "green",
            july: "green",
            agst: "green",
            sept:"green",
            oct: "green",
            nov: "green",

            dec: "green"
          },
          {
            value: false,
            name: "Longan",
            category: "Beverage",
            jan: "yellow",

            feb: "yellow",
            march: "green",
            april: "green",
            may:"green",
            june: "green",
            july: "yellow",
            agst: "yellow",
            sept:"yellow",
            oct: "yellow",
            nov: "yellow",

            dec: "yellow"
          },
          {
            value: false,
            name: "Lychee",
            category: "Beverage",
            jan: "red",

            feb: "red",
            march: "red",
            april: "red",
            may:"green",
            june: "green",
            july: "green",
            agst: "green",
            sept:"yellow",
            oct: "red",
            nov: "red",

            dec: "red"
          },
          {
            value: false,
            name: "Mango",
            category: "Beverage",
            jan: "yellow",

            feb: "yellow",
            march: "green",
            april: "green",
            may:"green",
            june: "yellow",
            july: "yellow",
            agst: "yellow",
            sept:"yellow",
            oct: "green",
            nov: "green",

            dec: "green"
          },
          {
            value: false,
            name: "Mangosteen",
            category: "Beverage",
            jan: "red",

            feb: "red",
            march: "red",
            april: "green",
            may:"green",
            june: "green",
            july: "yellow",
            agst: "red",
            sept:"red",
            oct: "red",
            nov: "red",

            dec: "red"
          },
          {
            value: false,
            name: "Milk fruit",
            category: "Beverage",
            jan: "green",

            feb: "green",
            march: "green",
            april: "red",
            may:"red",
            june: "red",
            july: "red",
            agst: "red",
            sept:"red",
            oct: "yellow",
            nov: "yellow",

            dec: "green"
          },
          {
            value: false,
            name: "Passionfruit",
            category: "Beverage",
            jan: "green",

            feb: "green",
            march: "green",
            april: "red",
            may:"red",
            june:"green",
            july: "green",
            agst: "green",
            sept:"green",
            oct: "green",
            nov: "green",

            dec: "green"
          },
          {
            value: false,
            name: "Pear",
            category: "Beverage",
            jan: "red",

            feb: "red",
            march: "red",
            april: "red",
            may:"green",
            june:"green",
            july: "green",
            agst: "red",
            sept:"red",
            oct: "red",
            nov: "red",

            dec: "red"
          },
          {
            value: false,
            name: "Persimmom",
            category: "Beverage",
            jan: "red",

            feb: "red",
            march: "red",
            april: "red",
            may:"red",
            june:"red",
            july: "red",
            agst: "green",
            sept:"green",
            oct: "green",
            nov: "green",

            dec: "yellow"
          },
          {
            value: false,
            name: "Pineapple",
            category: "Beverage",
            jan: "green",

            feb: "yellow",
            march: "yellow",
            april: "green",
            may:"green",
            june:"green",
            july: "yellow",
            agst: "yellow",
            sept:"yellow",
            oct: "green",
            nov: "green",

            dec: "green"
          },
          {
            value: false,
            name: "Plum",
            category: "Beverage",
            jan: "green",

            feb: "yellow",
            march: "red",
            april: "red",
            may:"green",
            june:"green",
            july: "green",
            agst: "green",
            sept:"red",
            oct: "red",
            nov: "red",

            dec: "green"
          },
          {
            value: false,
            name: "Pomelo",
            category: "Beverage",
            jan: "green",

            feb: "green",
            march: "yellow",
            april: "yellow",
            may:"yellow",
            june:"green",
            july: "green",
            agst: "green",
            sept:"green",
            oct: "green",
            nov: "green",

            dec: "green"
          },
          {
            value: false,
            name: "Rambutton",
            category: "Beverage",
            jan: "yellow",

            feb: "yellow",
            march: "yellow",
            april: "yellow",
            may:"yellow",
            june:"green",
            july: "green",
            agst: "green",
            sept:"yellow",
            oct: "yellow",
            nov: "yellow",

            dec: "yellow"
          },
          {
            value: false,
            name: "Red-papaya",
            category: "Beverage",
            jan: "yellow",

            feb: "yellow",
            march: "red",
            april: "red",
            may:"red",
            june:"green",
            july: "green",
            agst: "green",
            sept:"green",
            oct: "green",
            nov: "yellow",

            dec: "yellow"
          },
          {
            value: false,
            name: "Sapodilla",
            category: "Beverage",
            jan: "green",

            feb: "green",
            march: "yellow",
            april: "yellow",
            may:"red",
            june:"red",
            july: "red",
            agst: "red",
            sept:"green",
            oct: "green",
            nov: "green",

            dec: "green"
          },
          {
            value: false,
            name: "Soursop",
            category: "Beverage",
            jan: "green",

            feb: "green",
            march: "red",
            april: "red",
            may:"red",
            june:"green",
            july: "green",
            agst: "green",
            sept:"green",
            oct: "green",
            nov: "green",

            dec: "green"
          },
          {
            value: false,
            name: "Sweetsop",
            category: "Beverage",
            jan: "green",

            feb: "green",
            march: "yellow",
            april: "yellow",
            may:"green",
            june:"green",
            july: "green",
            agst: "green",
            sept:"green",
            oct: "green",
            nov: "green",

            dec: "green"
          },
          {
            value: false,
            name: "Custard Apple",
            category: "Beverage",
            jan: "green",

            feb: "green",
            march: "yellow",
            april: "yellow",
            may:"green",
            june:"green",
            july: "green",
            agst: "green",
            sept:"green",
            oct: "green",
            nov: "green",

            dec: "green"
          },
          {
            value: false,
            name: "Tamarind",
            category: "Beverage",
            jan: "green",

            feb: "green",
            march: "green",
            april: "green",
            may:"green",
            june:"green",
            july: "green",
            agst: "green",
            sept:"green",
            oct: "green",
            nov: "green",

            dec: "green"
          },
          {
            value: false,
            name: "Watermelon",
            category: "Beverage",
            jan: "green",

            feb: "green",
            march: "green",
            april: "green",
            may:"green",
            june:"green",
            july: "green",
            agst: "green",
            sept:"green",
            oct: "green",
            nov: "green",

            dec: "green"
          },
          {
            value: false,
            name: "White Guava",
            category: "Beverage",
            jan: "green",

            feb: "green",
            march: "green",
            april: "green",
            may:"green",
            june:"green",
            july: "green",
            agst: "green",
            sept:"green",
            oct: "green",
            nov: "green",

            dec: "green"
          },
          {
            value: false,
            name: "Avocado",
            category: "Beverage",
            jan: "green",

            feb: "green",
            march: "yellow",
            april: "green",
            may:"green",
            june:"green",
            july: "green",
            agst: "green",
            sept:"green",
            oct: "yellow",
            nov: "yellow",

            dec: "green"
          },
          {
            value: false,
            name: "Young Coconut",
            category: "Beverage",
            jan: "green",

            feb: "green",
            march: "green",
            april: "green",
            may:"green",
            june:"green",
            july: "green",
            agst: "green",
            sept:"green",
            oct: "green",
            nov: "green",

            dec: "green"
          },



          
        ]
      },
      
    ]
  }),
  computed: {
    headers0() {
      return this.headers.map(header =>
        Object.assign({}, header, { fixed: false })
      );
    },
    headers2() {
      return [
        { text: "", fixed: true, width: "100px", sortable: false }
      ].concat(this.headers);
    },
    headers3() {
      return [{ text: "", fixed: true, width: "100px" }].concat(this.headers);
    },
    headers5() {
      return this.headers3;
    }
  },
  methods: {
    getColor(fruit) {
      if (fruit === "apple") {
        return "red";
      } else if (fruit === "lemon") {
        return "yellow";
      } else if (fruit === "orange") {
        return "orange";
      } else if (fruit === "grape") {
        return "purple";
      } else {
        return "blue";
      }
    }
  }
};
</script>
<style scoped>
#arrowdown {
  text-align: right;
}
</style>
